import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { GlobalSearchResponseT } from '../types/global_search.types'

export class GlobalSearchRepository {
    search(name: string): Promise<AxiosResponse<GlobalSearchResponseT>> {
        const params = { name }

        return http.get('/analytics/api/global-search', { params })
    }
}
